import { api } from './client';

/** Mirrors WorkerContractStateDto (Api/UseCases/Payroll). */
export interface WorkerContractStateDto {
  workerId: number;
  workerName: string;
  contractNumber: number;
  contractSerial: string;
  hiredFrom: string;
  firedFrom: string | null;
  isActive: boolean;
  wageType: string; // 'p' | 'v'
  contractWage: number;
  extraPay: number;
  workLoad: number;
  position: string | null;
  npd: number | null;
  pnpd: number | null;
  accumulatesPension: boolean;
  lpkCode: number | null;
  contractSubtype: number | null;
}

export interface WorkerEventDto {
  id: number;
  eventType: string;
  effectiveFrom: string;
  amountValue: number | null;
  textValue: string | null;
  contractNumber: number;
  contractSerial: string | null;
}

export interface AddWorkerEventRequest {
  workerId: number;
  eventType: string;
  effectiveFrom: string;
  contractNumber: number;
  contractSerial?: string | null;
  amountValue?: number | null;
  textValue?: string | null;
}

/** The event-type picker labels (WorkerEventTypes codes, legacy darbuotojai_d). */
export const WORKER_EVENT_TYPES: { code: string; label: string; needsAmount: boolean; needsText: boolean }[] = [
  { code: 'd', label: 'Įdarbinimas', needsAmount: false, needsText: false },
  { code: 'n', label: 'Atleidimas', needsAmount: false, needsText: false },
  { code: 'u', label: 'Atlyginimas', needsAmount: true, needsText: true },
  { code: 'i', label: 'Priedas', needsAmount: true, needsText: false },
  { code: 'k', label: 'Etatas', needsAmount: true, needsText: false },
  { code: 'f', label: 'Pareigos', needsAmount: false, needsText: true },
  { code: 'p', label: 'NPD', needsAmount: true, needsText: false },
  { code: 'r', label: 'PNPD', needsAmount: true, needsText: false },
  { code: 's', label: 'Pensijos kaupimas', needsAmount: true, needsText: false },
  { code: 'l', label: 'LPK kodas', needsAmount: true, needsText: false },
  { code: 'm', label: 'Sutarties porūšis', needsAmount: true, needsText: false },
];

export const workerContractsApi = {
  list: () => api.get<WorkerContractStateDto[]>('/payroll/contracts'),

  timeline: (workerId: number) => api.get<WorkerEventDto[]>(`/payroll/contracts/${workerId}`),

  addEvent: (request: AddWorkerEventRequest) =>
    api.post<number>('/payroll/contracts/events', request),

  correctEvent: (eventId: number, request: { effectiveFrom?: string; amountValue?: number | null; textValue?: string | null }) =>
    api.post<void>(`/payroll/contracts/events/${eventId}/correct`, request),
};
